import { render, staticRenderFns } from "./CompetitionListJudgeLayout.vue?vue&type=template&id=414382ad&scoped=true"
import script from "./CompetitionListJudgeLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionListJudgeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414382ad",
  null
  
)

export default component.exports